export enum SCREENS {
  MY_MUSIC = "/music/:tab",
  MY_MUSIC_LIBRARY = "/library",
  MY_MUSIC_RELEASES = "/releases",
  RELEASE_CHECKOUT = "/checkout/releases/:transaction_code",
  RELEASE_DETAIL = "/release/:release_id",
  EDIT_RELEASE_DETAIL = "/release/:release_id/edit",
  CREATE_RELEASE = "/release/:release_id/create/:flow",
  PAGINATED_STUDIOS = "/paginated-studios",
  PAGINATED_ENGINEERS = "/paginated-engineers",
  THE_SOUND_OF_TOMORROW = "/thesoundoftomorrow",
  BLOG_SCREEN = "/community?path=engineears-blogs-iz6jdkkr",
  SOUND_OF_TOMORROW = "/soundoftomorrow",
  SEEING_SOUNDS = "/seeingsounds",
  DREAMVILLE = "/dreamville",
  NAMM = "/namm",
  MIXHER = "/mixher",
  SIGN_IN_SCREEN = "/signin",
  SIGN_UP_SCREEN = "/signup",
  HOME_SCREEN = "/",
  SIGNED_OUT_HOME_SCREEN = "/for-all",
  FOR_ARTISTS = "/for-artists",
  FOR_ENGINEERS = "/for-engineers",
  FOR_LABELS = "/for-labels",
  FOR_STUDIOS = "/for-studios",
  CUSTOMIZE_PROFILE_FOR_ARTISTS = "/customize-your-profile-for-artists",
  BOOKING_ENGINEERING_SERVICES_FOR_ARTISTS = "/booking-engineering-services",
  BOOKING_STUDIO_SESSIONS_FOR_ARTISTS = "/booking-studio-sessions",
  PROJECT_MANAGEMENT_TOOLS_FOR_ARTISTS = "/project-management-tools-for-artists",
  REPORTING_ANALYTICS_FOR_ARTISTS = "/reporting-analytics-for-artists",
  SYMPHONY = "/symphony",
  BUILD_PROFILE_FOR_ENGINEERS = "/build-your-profile-for-engineers",
  PROJECT_MANAGEMENT_TOOLS_FOR_ENGINEERS = "/project-management-tools",
  REPORTING_ANALYTICS_FOR_ENGINEERS = "/reporting-analytics",
  BUILD_PROFILE_FOR_STUDIOS = "/build-your-profile-for-studios",
  SESSION_MANAGEMENT_TOOLS = "/session-management-tools",
  STUDIO_TEAMS_RESOURCES = "/studio-teams-resources",
  GETTING_STARTED_FOR_LABELS = "/getting-started-for-labels",
  BOOK_AUDIO_ENGINEERING_SERVICES_FOR_LABELS = "/book-audio-engineering-services-for-labels",
  BOOKING_STUDIO_SESSIONS_FOR_LABELS = "/booking-studio-sessions-for-labels",
  PROJECT_MANAGEMENT_TOOLS_FOR_LABELS = "/project-management-tools-for-labels",
  PROFILE_SCREEN = "/:username",
  MESSAGES = "/messages",
  COMMUNITY = "/community",
  DASHBOARD_FAVORITES = "/dashboard/favorites",
  DASHBOARD = "/dashboard",
  NOTIFICATIONS = "/notifications",
  MOBILE_CHECKOUT = "/checkout",
  STUDIO_SCREEN = "/studio/:username",
  STUDIO_ROOM = "/studio/:username/:room_id",
  MOBILE_PROJECT_REVIEW = "/project-review",
  PROJECTS_NO_TAB = "/projects",
  PROJECTS = "/projects/:tab",
  SEARCH = "/search",
  FIND_MY_ENGINEER = "/findmyengineer",
  PROJECT = "/project/:project_id",
  KLARNA_PAYMENT_REDIRECT = "/klarnapayment",
  AFFIRM_PAYMENT_REDIRECT = "/affirmpayment",
  VERIFY_EMAIL = "/verify-email",
  UPLOAD_SCREEN = "/upload/:project_id",
  LOGGED_OUT_REVIEW = "/listen/:project_id",
  LOGGED_OUT_SESSION_DETAILS = "/session-details/:project_id",
  SETUP_STRIPE = "/stripe-setup",
  PASSWORD_RESET = "/reset-password",
  LOG_OUT_ACTION = "/log-out-action",
  ADD_SUBSCRIPTION = "/add-subscription",
  ADD_ARTIST_SUBSCRIPTION = "/add-artist-subscription",
  UPDATE_ACCOUNT_DETAILS = "update-account-details",
  UPDATE_CONTACT_INFO = "update-contact-info",
  LOAD_PREDEFINED_PROJECT = "/purchase-project",
  TRANSACTION_OVERVIEW = "/transaction-overview/:transaction_id",
  RECORDING_BOOKING_CHECKOUT = "/recording-session/checkout",
  RECORDING_BOOKING_SCREEN = "/recording-booking",
  CUSTOMER_PORTAL = "/customer-portal/:tab",
  SCHEDULED_PROJECT_OVERVIEW_SCREEN = "/project-overview/:scheduled_project_id",
  FEATURED_TRACK_REQUEST = "/featured-track/:featured_track_id",
  AANDR_SETUP_SCREEN = "/for-aandr",
  DOLBY_REGISTRATION_CHECKPOINT = "/dolby-registration",
  PRO_TOOLS_REGISTRATION_CHECKPOINT = "/protools-registration",
  NAMM_REGISTRATION_CHECKPOINT = "/namm-registration",
  USER_FEEDBACK_RATING = "/user-feedback",
  RECORDING_SESSION = "/session/:project_id",
  CASH_APP_REDIRECT = "/cashapppayment",
  SETTINGS_SCREEN = "/settings",
  ONBOARDING_RSVP_SCREEN = "/onboardingrsvp",
  TEAM_INVITE_SCREEN = "/invites",
  ADMIN_DASHBOARD = "/admin-dashboard",
  TRANSACTION_BOOKING_SCREEN = "/booking/:transaction_code",
  BOOKINGS = "/bookings/:tab",
  MUSO_AUTH_REDIRECT_SCREEN = "/musoauth",
  MUSO_SELECTION_SCREEN = "/muso/:tab",
  LIVESTREAM_SCREEN = "/livestream",
  AUTH_SCREEN = "/auth",
  SELECT_FEATURED_TRACK = "/select-featured-track",
  SUBSCRIPTION_SUCCESS = "/subscription-success",
  DISTRIBUTION = "/distribution",
  BEAT_MATRIX = "/beatmatrix",
  BEAT_MATRIX_SUBMISSIONS = "/beatmatrix-submissions",
  DOLBY_ATMOS = "/dolbyatmos",
  PRO_TOOLS = "/protools",
  ADMIN_PERFORMANCE_CHART_SCREEN = "/admin/performance",
}
